import VueRouter from 'vue-router'
import Vue from 'vue'

import Home from '../components/Home/Home.vue'
import Privacy from '../components/Other/Privacy'
import Agreement from '../components/Other/Agreement'

Vue.use(VueRouter)

var router = new VueRouter({
  routes: [
    {
      path: '/',
      component: Home,
      meta: { show: true }
    },
    {
      path: '/privacy',
      component: Privacy,
      meta: { show: false }
    },
    {
      path: '/agreement',
      component: Agreement,
      meta: { show: false }
    }
  ],
  mode: 'hash'

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js